import {
  compareBool,
  compareStrings,
} from '../../../../../../../../../../common/policyPanel/uiSettings/gridTemplate/utils/sorters';
import { ColumnKeys } from '../grid-config';
import { ExchangeContentControlContentFilteringRuleSettingsFilterByExpression } from '@nirvana/shared/dtos/types/policies/common';
import { getExchangeContentControlExpressionType } from '../../../../../../../../utils/uiSettings/exchange/exchange-protection.values';

// sort by column type
export function sortByColumn(
  item1: ExchangeContentControlContentFilteringRuleSettingsFilterByExpression,
  item2: ExchangeContentControlContentFilteringRuleSettingsFilterByExpression,
  columnName: string,
  direction: string
): number {
  switch (columnName) {
    case ColumnKeys.TYPE:
      return compareStrings(
        getExchangeContentControlExpressionType(item1.type),
        getExchangeContentControlExpressionType(item2.type),
        direction
      );

    case ColumnKeys.TEXT:
      return compareStrings(item1.text, item2.text, direction);

    case ColumnKeys.MATCH_CASE:
      return compareBool(item1.matchCase, item2.matchCase, direction);

    case ColumnKeys.WHOLE_WORD:
      return compareBool(item1.wholeWord, item2.wholeWord, direction);
  }

  return 0;
}
